"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconOurPeople = function SvgIconOurPeople(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "our people icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Our People Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 13.533a3.758 3.758 0 003.75-3.767A3.758 3.758 0 0024 6a3.758 3.758 0 00-3.75 3.766A3.758 3.758 0 0024 13.533zm7.839 12.664a1.495 1.495 0 011.47-.41C38.913 27.122 42 29.412 42 32.232c0 4.788-8.442 7-15.672 7.444h-.093a1.503 1.503 0 01-1.544-1.462 1.504 1.504 0 011.456-1.551C34.703 36.149 39 33.542 39 32.233c0-.804-1.7-2.4-6.384-3.516a1.502 1.502 0 01-1.13-1.03 1.511 1.511 0 01.353-1.49zm-14.735 6.321a.748.748 0 01.77.284l3.659 4.911a.756.756 0 01-.218 1.1l-5.183 3.082a.747.747 0 01-.813-.031.755.755 0 01-.306-.758l.364-1.904a.378.378 0 00-.287-.439C10.213 37.656 6 35.533 6 32.233c0-2.822 3.087-5.112 8.691-6.449a1.507 1.507 0 01.693 2.932C10.7 29.832 9 31.43 9 32.232c0 .992 2.307 2.546 6.636 3.556a.373.373 0 00.45-.302l.45-2.374a.752.752 0 01.568-.594zm9.396-.067a.751.751 0 01-.75.667h-3.494a.751.751 0 01-.75-.667l-.76-6.533a.377.377 0 00-.373-.333H18.75a.752.752 0 01-.75-.753v-3.616c0-3.328 2.686-6.026 6-6.026s6 2.698 6 6.026v3.616a.752.752 0 01-.75.753h-1.617c-.19 0-.35.143-.373.333l-.76 6.533z"
  }));
};

var _default = SvgIconOurPeople;
exports.default = _default;